import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { fetchMaterials } from '../api/api';
import { CircularProgress } from '@material-ui/core';

import Item from './Item';
import Search from './Search';



const styles = theme => ({
  root: {
    margin: '30px 0px'
  }
});

class Materials extends Component {

  allMaterials = [];

  state = {
    materials: [],
    isLoading: false
  }

  update = val => {
    if (val.length >= 3) {
      const filtered = this.allMaterials.filter(d =>
        d.description.toLowerCase().includes(val.toLowerCase())
      );

      this.setState({materials: filtered});
    } else {
      this.setState({ materials: this.allMaterials })
    }
  }

  componentDidMount() {
    this.loadMaterials();
  }

  loadMaterials = async () => {
    this.setState({isLoading: true});
    const materials =  await fetchMaterials({
    });
    this.setState({materials, isLoading: false}, () => {
      this.allMaterials = materials;
    });

    return materials;
  }

  render() {
    const { classes } = this.props;
    const { materials, isLoading } = this.state;
    if (isLoading) {
      return <CircularProgress />
    }
    return (
      <div className={classes.root}>
        <Search onUpdate={this.update} />
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="flex-start"
        >
          {materials.map(material => <Item
                      key={material._id}
                      section={material}
                      purchasable
                      height={180}
                      width={4}
                      type="photo" />
                    )}
        </Grid>
      </div>
    )
  }
}

Materials.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Materials);
